import React, { useState } from "react";

import {
    TextInput,
    Dimensions,
    View,
    Modal,
    Text,
    TouchableOpacityProps,
    TouchableOpacity
} from "react-native";
import SVGView from "../utils/SvgView";
import AppTheme from "../utils/Theme";
import Style from "../utils/Style";

interface RoundIconButtonProps extends TouchableOpacityProps {
    iconName: any;
    backgroundColor: string;
    iconSize?: number;
    size?: "s" | "m" | "l"
}

const RoundIconButton = (props: RoundIconButtonProps) => {

    const appTheme: AppTheme = new AppTheme();

    const { iconName, backgroundColor = appTheme.darkBlue, iconSize, size = "l", disabled, ...restProps } = props;

    const buttonSize: number = size === "l" ? appTheme.pixelPerfect(70) : size === "m" ? appTheme.pixelPerfect(50) : appTheme.pixelPerfect(40);
    const buttonIconSize: number = ((iconSize !== undefined) || (size === "l")) ? appTheme.pixelPerfect(42) : size === "m" ? appTheme.pixelPerfect(32) : appTheme.pixelPerfect(22);

    return (
        <TouchableOpacity
            disabled={disabled}
            style={[Style.shadowed, {
                justifyContent: "center",
                alignItems: "center",
                borderRadius: buttonSize/2,
                width: buttonSize,
                height: buttonSize,
                backgroundColor: backgroundColor,
                opacity: disabled === true ? 0.5 : 1
            }]}
            {...restProps}>
            <SVGView Component={iconName} size={buttonIconSize} color={appTheme.white} />
        </TouchableOpacity>
    )
}

export default RoundIconButton;
